<template>
  <section class="py-5 w-100">
    <ul class="soha-timeline">
      <slot />
    </ul>
  </section>
</template>

<script>
import "@/assets/css/components/base/timeline.css";
export default {
  name: "TimeLine",
};
</script>

<style scoped></style>
